/**
 * This is a small library of utility functions that may be used on the site globally.
 */

/**
 * Replace the site's copyright year with the current year.
 *
 * @export
 */
export function copyright() {
    const currentYear = new Date().getFullYear();
    const copySpans = document.querySelectorAll('.copy-year');

    for (let i = 0; i < copySpans.length; ++i) {
        copySpans[i].innerHTML = currentYear;
    }
}

/**
 * Add a rel attribute to all links with a '_blank' target to prevent tabnabbing.
 *
 * @export
 */
export function noTabnabbing() {
    const targets = document.querySelectorAll('[target=_blank]');

    for (let i = 0; i < targets.length; ++i) {
        targets[i].setAttribute('rel', 'noopener noreferrer');
    }
}


// WEBPACK FOOTER //
// ./src/js/partials/utilities.js